import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { closeModal } from 'Core/redux/main/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import FutureActionsAddEdit from './future-actions-add-edit';
import FutureActionsDetailsModal from './future-actions-details-modal';

const { FUTUREACTIONS_ADD_EDIT, FUTUREACTIONS_DETAILS } = MODAL_TYPES;

const FutureActionsModals = () => {
  const dispatch = useDispatch();
  const modals = useSelector(state => state.main.modals);

  console.log('🔍 FutureActionsModals - modals state:', modals);
  
  // Find modals by ID in the array
  const addEditModal = modals.find(modal => modal.id === FUTUREACTIONS_ADD_EDIT);
  const detailsModal = modals.find(modal => modal.id === FUTUREACTIONS_DETAILS);
  
  console.log('🔍 FutureActionsModals - addEditModal:', addEditModal);
  console.log('🔍 FutureActionsModals - detailsModal:', detailsModal);

  const handleCloseModal = (modalType) => {
    dispatch(closeModal(modalType));
  };

  return (
    <>
      {addEditModal && (
        <FutureActionsAddEdit
          showModal={true}
          modalData={addEditModal.data}
          onCloseModal={() => handleCloseModal(FUTUREACTIONS_ADD_EDIT)}
        />
      )}
      {detailsModal && (
        <FutureActionsDetailsModal
          showModal={true}
          modalData={detailsModal.data}
          onCloseModal={() => handleCloseModal(FUTUREACTIONS_DETAILS)}
        />
      )}
    </>
  );
};

export default FutureActionsModals;
